import { buildProps, definePropType, generateId } from '@jdesign-vue/utils'
import type { Component, ExtractPropTypes, VNode } from 'vue'
import type { CollapseActiveName } from './collapse'

export const collapseItemProps = buildProps({
  title: {
    type: String,
    default: '',
  },
  name: {
    type: definePropType<CollapseActiveName>([String, Number]),
    default: () => generateId(),
  },
  disabled: Boolean,
  /**
   * @description 自定义额外图标，渲染在右侧展开/折叠图标的前面，
   * 也可以使用具名插槽 `extra-icon` 传入
   */
  extraIcon: {
    type: definePropType<string | Component | VNode | (() => VNode)>([
      String,
      Object,
      Function,
    ]),
    default: '',
  },
} as const)
export type CollapseItemProps = ExtractPropTypes<typeof collapseItemProps>